import React, { useEffect } from 'react';

type UseClickOutsideProps = {
  ref: React.RefObject<HTMLElement | null>;
  onClickOutside: () => void;
};

export const useClickOutside = ({ ref, onClickOutside }: UseClickOutsideProps) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
};
